import { mapState } from "vuex";
import {
  Drawer,
  Form,
  FormItem,
  Input,
  InputNumber,
  RadioGroup,
  Radio,
  Checkbox,
  Tooltip,
  Button,
} from "element-ui";
import isMobile from "@/shared/utils/isMobile";

const AddShareLinkDrawer = {
  data() {
    const checkSymbol = (rule, value, callback) => {
      if (
        !this.addShareLinkFormVal.forexSelect &&
        !this.addShareLinkFormVal.energySelect &&
        !this.addShareLinkFormVal.indicesSelect &&
        !this.addShareLinkFormVal.metalsSelect &&
        !this.addShareLinkFormVal.cryptoSelect
      ) {
        callback(new Error(this.$t("Common_valid_CheckSymbolNot")));
      } else {
        callback();
      }
    };
    const checkPercent = (rule, value, callback) => {
      if (!value) {
        return callback(
          new Error(this.$t("Common_Valid_CheckCopyPercentNotNull"))
        );
      } else {
        var reg = /^([1-9]\d|[1-9]\d{2,4}|100000)$/;
        if (!reg.test(value)) {
          callback(new Error(this.$t("Common_Valid_CheckCopyPercentNotF")));
        } else {
          callback();
        }
      }
    };

    return {
      addShareLinkDrawerVisible: false,
      addShareLinkFormVal: {
        following: 100,
        maxVolume: undefined,
        forexSelect: true,
        metalsSelect: true,
        energySelect: true,
        indicesSelect: true,
        cryptoSelect: true,
        autoRecon: true,
        agreeActivation: true,
        remark: "",
      },
      addShareLinkFormRules: {
        symbolGroup: [{ validator: checkSymbol, trigger: "change" }],
        following: [{ validator: checkPercent, trigger: "change" }],
      },
      loading: false,
    };
  },
  computed: {
    ...mapState(["userInfo", "checkPortfolio"]),
  },
  props: ["reloadTable"],
  mounted() {},
  created() {},
  methods: {
    open() {
      this.addShareLinkDrawerVisible = true;
    },
    close() {
      this.$refs.shareLinkForm.resetFields();
      this.addShareLinkDrawerVisible = false;
    },
    handleSubmit() {
      this.$refs.shareLinkForm.validate((valid) => {
        if (valid) {
          this.loading = true;

          const params = {
            portfolioId: this.checkPortfolio.id,
            ...this.addShareLinkFormVal,
            maxVolume:
              this.addShareLinkFormVal.maxVolume === undefined
                ? 0
                : this.addShareLinkFormVal.maxVolume,
          };

          this.$axios
            .post("/api/Portfolio/GenerageShareLink", params)
            .then((res) => {
              let dt = res.data;
              if (dt.isSuccess) {
                this.$notify.success({
                  title: this.$t("Common_Prompt"),
                  message: this.$t("Common_OperateSuccess"),
                });
                this.reloadTable();
                this.close();
              } else {
                this.$notify.error({
                  title: this.$t("Common_Prompt"),
                  message: dt.result,
                });
              }
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },

  render() {
    return (
      <Drawer
        title={this.$t("Add_Share_Link")}
        class="drawerCommon"
        appendToBody
        onClose={this.close}
        closeOnPressEscape={false}
        visible={this.addShareLinkDrawerVisible}
        direction="rtl"
      >
        <div class="drawerContent">
          <Form
            ref="shareLinkForm"
            labelPosition={isMobile ? "top" : "right"}
            labelWidth="150px"
            class="drawerForm"
            props={{ model: this.addShareLinkFormVal }}
            addSules={this.addShareLinkFormRules}
          >
            {/* 跟单比例 */}
            <FormItem prop="following">
              <span slot="label">
                <span class="label-box">
                  <span>{this.$t("Common_TableTitle_CopyRatio")} </span>
                  <Tooltip placement="bottom">
                    <svg-icon class="labelIcon" icon-class="LabelIcon" />
                    <div slot="content">
                      <div>{this.$t("ViewInvitation_CopyPercentTxt")}</div>
                      <br />
                      <div>{this.$t("ViewInvitation_CopyPercentTxt1")}</div>
                    </div>
                  </Tooltip>
                </span>
              </span>
              <div class="formPercentDiv">
                <Input v-model={this.addShareLinkFormVal.following} min={1} type="number">
                  <span slot="suffix">%</span>
                </Input>
              </div>
            </FormItem>
            {/* 最大交易量 */}
            <FormItem prop="maxVolume">
              <span slot="label">
                <span class="label-box">
                  <span>{this.$t("Common_TableTitle_MaxLot")} </span>
                  <Tooltip placement="bottom">
                    <svg-icon class="labelIcon" icon-class="LabelIcon" />
                    <div slot="content">
                      <div>{this.$t("ViewInvitation_MaxVolumnTxt")}</div>
                      <br />
                      <div>{this.$t("ViewInvitation_MaxVolumnTxt1")}</div>
                    </div>
                  </Tooltip>
                </span>
              </span>

              <InputNumber
                v-model={this.addShareLinkFormVal.maxVolume}
                controlsPosition="right"
                min={0}
                precision={2}
                class="creaseInput"
                placeholder={this.$t("Common_TR_VolumeNotLimit")}
              />
              <b class="formLots">lots</b>
            </FormItem>
            {/* 交易对 */}
            <FormItem
              label={this.$t("Common_TableTitle_Instruments")}
              prop="symbolGroup"
            >
              <Checkbox v-model={this.addShareLinkFormVal.forexSelect}>
                {this.$t("Common_Fx")}
              </Checkbox>
              <Checkbox v-model={this.addShareLinkFormVal.metalsSelect}>
                {this.$t("Common_Metal")}
              </Checkbox>
              <Checkbox v-model={this.addShareLinkFormVal.energySelect}>
                {this.$t("Common_Energy")}
              </Checkbox>
              <Checkbox v-model={this.addShareLinkFormVal.indicesSelect}>
                {this.$t("Common_Indices")}
              </Checkbox>
              <Checkbox v-model={this.addShareLinkFormVal.cryptoSelect}>
                {this.$t("Common_Crypto")}
              </Checkbox>
            </FormItem>
            {/* 自动补单 */}
            <FormItem prop="autoRecon">
              <span slot="label">
                <span class="label-box">
                  <span>{this.$t("Common_TableTitle_AutoMatchOrder")} </span>
                  <Tooltip placement="bottom">
                    <svg-icon class="labelIcon" icon-class="LabelIcon" />
                    <div slot="content">
                      {this.$t("ViewInvitation_IsAutoTxt")}
                    </div>
                  </Tooltip>
                </span>
              </span>
              <RadioGroup v-model={this.addShareLinkFormVal.autoRecon}>
                <Radio label={true}>{this.$t("Common_Yes")}</Radio>
                <Radio label={false}>{this.$t("Common_No")}</Radio>
              </RadioGroup>
            </FormItem>
            {/* 激活状态 */}
            <FormItem prop="agreeActivation">
              <span slot="label">
                <span class="label-box">
                  <span>{this.$t("Common_TableTitle_ActivationStatus")} </span>
                  <Tooltip placement="bottom">
                    <svg-icon class="labelIcon" icon-class="LabelIcon" />
                    <div slot="content">
                      {this.$t("ViewInvitation_MainActiveTxt")}
                    </div>
                  </Tooltip>
                </span>
              </span>
              <RadioGroup v-model={this.addShareLinkFormVal.agreeActivation}>
                <Radio label={true}>{this.$t("Common_Yes")}</Radio>
                <Radio label={false}>{this.$t("Common_No")}</Radio>
              </RadioGroup>
            </FormItem>
            {/* 备注 */}
            <FormItem prop="remark" label={this.$t("Remark")}>
              <Input v-model={this.addShareLinkFormVal.remark} maxlength={50} />
            </FormItem>
          </Form>
          <div class="drawerBtns">
            {/* 保存按钮 */}
            <Button
              class="confirmDialogBtn"
              v-loading={this.loading}
              onClick={this.handleSubmit}
            >
              {this.$t("Common_Save")}
            </Button>
            {/* 关闭按钮 */}
            <Button class="cancelDialogBtn" onClick={this.close}>
              {this.$t("Common_CloseWindow")}
            </Button>
          </div>
        </div>
      </Drawer>
    );
  },
};

export default AddShareLinkDrawer;
